module.exports = __webpack_public_path__ + "img/thank-you.07e31469.gif";